import { Button, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

type ButtonDirection = 'prev' | 'next';

export const ChipsContainer = styled.div<{ $isSecondaryVariant: boolean }>`
  padding: ${({ $isSecondaryVariant }) =>
    $isSecondaryVariant ? '16px 16px 0 16px' : '16px 0 0 0'};
  margin-bottom: 16px;
  display: flex;
  gap: ${({ $isSecondaryVariant }) => ($isSecondaryVariant ? '16px' : '8px')};
  overflow: hidden;
  flex-grow: 1;
  width: 100%;
  border-bottom: 1px solid var(--border-default);
`;

export const StyledButton = styled(Button)<{ $direction: ButtonDirection }>`
  position: absolute;

  ${({ $direction }) => {
    const gradientDirection = $direction === 'prev' ? 'left' : 'right';

    return css`
      background: linear-gradient(
        to ${gradientDirection},
        rgba(var(--background-default-rgb), 0.5) 0%,
        rgba(var(--background-default-rgb), 0.8) 12.5%,
        rgba(var(--background-default-rgb), 1) 50%
      );
      ${gradientDirection}: -3px;
    `;
  }};
`;

export const TabButton = styled.div.attrs({
  tabIndex: 0,
  role: 'tab',
})<{
  $isActive: boolean;
  $isSecondaryVariant: boolean;
}>`
  ${typographyV2.bodySm};
  color: var(--text-default);
  padding: ${({ $isSecondaryVariant }) =>
    $isSecondaryVariant ? '8px 15px' : '5px 11px'};
  cursor: pointer;
  width: fit-content;
  white-space: nowrap;

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: var(--text-primary);
      border-bottom: 2px solid var(--border-primary);
    `}
`;
